"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseGetOffersToJSON = exports.ResponseGetOffersFromJSONTyped = exports.ResponseGetOffersFromJSON = exports.instanceOfResponseGetOffers = void 0;
var Product_1 = require("./Product");
/**
 * Check if a given object implements the ResponseGetOffers interface.
 */
function instanceOfResponseGetOffers(value) {
    var isInstance = true;
    isInstance = isInstance && "basketId" in value;
    isInstance = isInstance && "offers" in value;
    return isInstance;
}
exports.instanceOfResponseGetOffers = instanceOfResponseGetOffers;
function ResponseGetOffersFromJSON(json) {
    return ResponseGetOffersFromJSONTyped(json, false);
}
exports.ResponseGetOffersFromJSON = ResponseGetOffersFromJSON;
function ResponseGetOffersFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'basketId': json['basketId'],
        'offers': (json['offers'].map(Product_1.ProductFromJSON)),
    };
}
exports.ResponseGetOffersFromJSONTyped = ResponseGetOffersFromJSONTyped;
function ResponseGetOffersToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'basketId': value.basketId,
        'offers': (value.offers.map(Product_1.ProductToJSON)),
    };
}
exports.ResponseGetOffersToJSON = ResponseGetOffersToJSON;
